import { createLogger } from 'shared/services/logger';
import {AnnotationsReaderBase} from './AnnotationsReaderBase';

const logger = createLogger('UScope:extensions:Snapshot:AnnotationsReader');

export class AnnotationsReader extends AnnotationsReaderBase {
  _capture (svgData, meta) {
    return new Promise(async (resolve, reject) => {
      // Render the annotations to an image
      const blob = new Blob([svgData], {type: 'image/svg+xml;charset=utf-8'});
      const blobUri = URL.createObjectURL(blob);
      const img = new Image();
      img.crossOrigin = 'anonymous';

      img.onload = () => {
        // store info needed for rendering.
        this._image = img;
        // X and Y were scaled against the viewport during the drawing phase, so we don't need to re-apply that
        // transformation here. Width and height data come from the raw SVG, which has not yet been scaled, so
        // we scale it here.
        this._position = {
          x: meta.x,
          y: meta.y,
          w: meta.w * meta.scale,
          h: meta.h * meta.scale
        };
        resolve();
      };
      img.onerror = (e) => {
        reject(e);
      };
      img.src = blobUri;
    });
  }

  render (context) {
    context.drawImage(this._image, -this._position.x, -this._position.y, this._position.w, this._position.h);
  }

  cleanup () {
    if (this.image) {
      URL.revokeObjectURL(this.image.src);
      delete this.rectangle;
      delete this.image;
    } else {
      logger.warn('Called Annotations::cleanup() more than once.');
    }
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/capturing/readers/AnnotationsReader.js